export default function AmiLoadingOverlay(parent, indicatorShown) {
    var text = <div id="conntxt">Loading Sock Chat...</div>;
    var indicator = <div id="indicator" />;
    var container = <div id="connmsg">
        <div id="info">
            {text}
            {indicator}
        </div>
    </div>;

    var appendTo = function(parent) { parent.appendChild(container); };
    var destroy = function() { container.parentNode.removeChild(container); };

    var showIndicator = function() { indicator.classList.remove('hidden'); };
    var hideIndicator = function() { indicator.classList.add('hidden'); };
    var toggleIndicator = function(visible) { indicator.classList[visible ? 'remove' : 'add']('hidden') };

    toggleIndicator(indicatorShown);

    if(parent !== undefined)
        appendTo(parent);

    return {
        close: function() {
            container.classList.add('connmsg-exit');
            setTimeout(destroy, 1000);
        },
        getElement: function() { return container; },
        appendTo: appendTo,
        showIndicator: showIndicator,
        hideIndicator: hideIndicator,
        toggleIndicator: toggleIndicator,
        setTextRaw: function(raw) { text.innerHTML = raw; },
        destroy: destroy,
    };
};
